module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_32-ad6b912bf9d25d28bb7267ba23e55840.png";